import ExtractImage from './ExtractImage/ExtractImage';
import { types } from './types';
function Actions(action, showAlert, variables, setOpenVariable, automId, variableRender, automVersionId) {
  if (action.actionName === types.EXTRACTIMAGE)
    return <ExtractImage action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} automId={automId} automVersionId={automVersionId} />;
}
export default Actions;